import { setPublicPath } from 'systemjs-webpack-interop';

setPublicPath('@ottu-mf/public_pages', 2);
